var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('date-picker',{attrs:{"value":_vm.convert(_vm.value),"placeholder":_vm.placeholder,"type":_vm.type,"format":_vm.format,"value-type":"format","name":_vm.name},on:{"input":_vm.onInput}})
}
var staticRenderFns = []

export { render, staticRenderFns }